import { QIcon_chevron_right } from '@repo/icons/index'
import { useAITutorPermission } from '../../../modules/apis/student/ai-tutor'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_membership } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { AI_TUTOR_ROLEPLAY } from '../../../modules/vars'

const SectionMembership = () => {
  const { t } = useTranslation()
  const { data: aiTutorMemebershipPermissionData } = useAITutorPermission(AI_TUTOR_ROLEPLAY)
  console.log(aiTutorMemebershipPermissionData?.current)

  const router = useAppRouter()
  const getFullUrl = useReturnFullUrl()

  const onClickMembership = () => {
    router.push(urls.student.newPortal.mypage.currentCredit(1), {
      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
      appSendData: {
        url: getFullUrl(urls.webview.mypage.currentCredit(1)),
      },
    })
  }

  // 실결제자
  if (aiTutorMemebershipPermissionData?.current) {
    return (
      <div className="border-1 rounded-[8px] p-[16px] flex flex-col cursor-pointer" onClick={onClickMembership}>
        <div className="flex flex-col gap-y-[8px]">
          <div className="flex">
            <div className="px-[6px] rounded-[4px] bg-gray-100 text-gray-800 Caption-12Bd pt-[2px]">
              {t(n_membership.label.use)}
            </div>
          </div>
          <div className="flex flex-row gap-[4px] items-center">
            <div className="Title2-18Bd">{aiTutorMemebershipPermissionData?.current?.plan_title || ''}</div>
            <QIcon_chevron_right width={20} height={20} />
          </div>
        </div>
        <hr className="my-[16px]" />
        <div className="text-gray-700 Body2-14Md py-[8px] flex flex-row justify-between">
          <div className="">{t(n_membership.list.period)}</div>
          <div className="">{aiTutorMemebershipPermissionData?.current?.period || ''}</div>
        </div>
      </div>
    )
  } else if (aiTutorMemebershipPermissionData?.temp_membership) {
    // 임의 지급된 멤버십
    return (
      <div className="border-1 rounded-[8px] p-[16px] flex flex-col cursor-pointer" onClick={onClickMembership}>
        <div className="flex flex-col gap-y-[8px]">
          <div className="flex">
            <div className="px-[6px] rounded-[4px] bg-gray-100 text-gray-800 Caption-12Bd pt-[2px]">
              {t(n_membership.label.use)}
            </div>
          </div>
          <div className="flex flex-row gap-[4px] items-center">
            <div className="Title2-18Bd">{aiTutorMemebershipPermissionData?.temp_membership?.plan_title || ''}</div>
            <QIcon_chevron_right width={20} height={20} />
          </div>
        </div>
        <hr className="my-[16px]" />
        <div className="text-gray-700 Body2-14Md py-[8px] flex flex-row justify-between">
          <div className="">{t(n_membership.sub.expired)}</div>
          <div className="">{aiTutorMemebershipPermissionData?.temp_membership?.expire_at || ''}</div>
        </div>
      </div>
    )
  }
}

export default SectionMembership
